import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class AllEmpService {

  httpUrl:any ;

  employee_id:any ;

  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl+"/hr";
  }

//Bank IFSC API
// async  bankIfsc(obj:any ) {
//   var str = "https://ifsc.razorpay.com/"+obj
//     const resp = await this.http.get<any>(str).toPromise().then(res => {
//    // return res;
//    return true;
//   }).catch(err=>{
//     return false
//   })
//   return resp;
// }

  //Account APIS;
  async  getAccountProjectHier(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/project/getHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp;
  }

  async  createAccountproject(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl+ '/accounts/hierarchies/project/createHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp;
  }
  async  createAccountproject1(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl+ '/accounts/hierarchies/project/1createHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp;
  }
  async  projectupdateHierarchy(obj:any ) {
    const resp = this.http.put<any>(this.main.httpUrl + '/accounts/hierarchies/project/updateHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  moveHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/project/moveHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  getCostCenter(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/costCenter/getCostCenter', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  getActivityHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/activity/getHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  getBudgetHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/budget/getHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  getProductHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/product/getHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }

  //Account APIS;

  async  getPayComponent(obj:any ) {

    const resp = await this.http.get<any>(this.main.httpUrl+'/hr/setting/getPayComponent' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async  updatePayComponent(obj:any ) {
    const resp = this.http.put<any>(this.main.httpUrl + '/hr/setting/updatePayComponent', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }





  async  getAllBugdet(obj:any ) {
    const resp = this.http.get<any>(this.main.httpUrl + '/hr/setting/getAllBugdet'+JSON.stringify(obj) ).toPromise().then(res => {
      return res
    });
    return resp
  }



  async  getAllProduct(obj:any ) {
    const resp = this.http.get<any>(this.main.httpUrl + '/hr/setting/getAllProduct'+JSON.stringify(obj) ).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  insertBudgetInfo(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/hr/setting/insertBudgetInfo', obj  ).toPromise().then(res => {
      return res
    });

    return resp
  }
  async  insertProductInfo(obj:any ) {
    const resp = this.http.post<any>(this.main.httpUrl + '/hr/setting/insertProductInfo', obj  ).toPromise().then(res => {
      return res
    });

    return resp
  }


  //budget info and product info

  //hr
  async updateEmployeeId(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/updateEmployeeId', (obj) ).toPromise().then(res => {
    return res;
    });
    return resp;
    }
  async  getEmployeeMasterData(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/empInfo/getAllListOfEmployee' + (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  getidwisedata(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/empInfo/getidwisedata' + (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updatedob(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/updatedob', (obj) ).toPromise().then(res => {
    return res;
    });
    return resp;
    }
  async  getAllPartyFields(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/empInfo/getAllListOfEmployee' + (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async  deleteEmployee(obj:any ) {
    const resp = await this.http.delete<any>(this.httpUrl+'/emp_info/empInfo/deleteEmployee' + (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async  inActiveEmployee(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/inActiveEmployee' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  activeEmployee(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/activeEmployee' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  // document insert
  async  insertDocument(obj:any ) {
    const resp = await this.http.post<any>(this.httpUrl+'/establishment_info/uploadfile/uploadFile' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  // async addEmployeePersonalInfo(obj:any ) {
  //   const resp = await this.http.post<any>(this.httpUrl+'/party/personal/addPersonalInfo', (obj)).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  async updatePersonalInfo(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/updateEmployeePersonalInfo', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  // Avinash
  async updatePhoneNo(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/empInfo/updateEmployeemoNo', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
async getJoinningDate(obj:any)
{
   const resp= await this.http.post(this.httpUrl + '/emp_info/empInfo/getJoinnigDate', obj  ).toPromise().then((res)=>{
    return res
   })

   return resp;
}

  async  getUploadedFiles(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/establishment_info/uploadfile/getUploadedFiles' + (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  getUploadedFileData(obj:any ) {
    const resp = await this.http.post(this.httpUrl+'/establishment_info/uploadfile/getUploadedFileData', obj ,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
  }
  else {
    return
  }
  }
  async getPersonalInfo(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/empInfo/getPersonalInfo' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  //Qualification Services
  async  getQualifications(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/education/getQualifications' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async addQualification(obj:any ) {
    const resp = await this.http.post<any>(this.httpUrl+'/emp_info/education/addQualification', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateQualifications(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/education/updateQualification', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteQualification(obj:any ) {
    const resp = await this.http.delete<any>(this.httpUrl+'/emp_info/education/deleteQualification' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  //Nominee Services
  async  getNominee(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/nominee/getNominee' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async addNominee(obj:any ) {
    const resp = await this.http.post<any>(this.httpUrl+'/emp_info/nominee/addNominee', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateNominee(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/nominee/updateNominee', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteNominee(obj:any ) {
    const resp = await this.http.delete<any>(this.httpUrl+'/emp_info/nominee/deleteNominee' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  //bank account info
  async getBankAcctInfo(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl + '/emp_info/bankAccount/getPartyBankAccount' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async addBankAcctInfo(obj:any ) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/hr/emp_info/bankAccount/addBankAccount', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateBankAcctInfo(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl + '/emp_info/bankAccount/updateBankAccount', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async deleteBankAcctInfo(obj:any ) {
  const resp = await this.http.delete<any>(this.httpUrl + '/emp_info/bankAccount/deleteBankAccount'+ JSON.stringify(obj) ).toPromise().then(res => {
    return res;
  });
  }
  async  getDependentInfo(obj:any ) {
    const resp = await this.http.get<any>(this.httpUrl+'/emp_info/dependent/getDependents' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async addDependentInfo(obj:any ) {
    const resp = await this.http.post<any>(this.httpUrl+'/emp_info/dependent/addDependent', (obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateDependentInfo(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl+'/emp_info/dependent/updateDependent', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteDependentInfo(obj:any ) {
    const resp = await this.http.delete<any>(this.httpUrl+'/emp_info/dependent/deleteDependent' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  //lic
  async getLicInfo(obj:any ) {

    const res = await this.http.get<any>(this.main.httpUrl + '/hr/emp_info/lic/getLicInfo'+obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async updateLicInfo(obj:any ) {

    const res = await this.http.put<any>(this.main.httpUrl + '/hr/emp_info/lic/updateLicInfo', obj  ).toPromise().then(res => {
      return res;

    });
    return res;

  }

  async addLicInfo(obj:any ) {

    const res = await this.http.post<any>(this.main.httpUrl + '/hr/emp_info/lic/addLicInfo', obj  ).toPromise().then(res => {
      return res;

    });
    return res;

  }

  async deleteLicInfo(obj:any ) {

    const res = await this.http.delete<any>(this.main.httpUrl + '/hr/emp_info/lic/deleteLicInfo'+obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }

}
